module.exports = __webpack_public_path__ + "img/20191112152748360截图20191112151557517.cbbb846e.jpg";